import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e2b7d684&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b7d684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/data/.jenkins/workspace/yyWebsite/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2b7d684')) {
      api.createRecord('e2b7d684', component.options)
    } else {
      api.reload('e2b7d684', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e2b7d684&scoped=true&", function () {
      api.rerender('e2b7d684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/transfer/index.vue"
export default component.exports